import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from '@mui/material';

import { tooltipSxElevated } from '../../../../components/shared/jernyTooltipStyling';

export default function GroupSettingsTitlebar({ groupName, isDirty, onSave, onCancel, dragHandleProps }) {
    return (
        <div id="group-settings-titlebar" className="yns-titlebar" {...dragHandleProps}>
            <span>Group Settings · {groupName}</span>
            <div className="yns-titlebar-actions">
                <Tooltip title="Save" componentsProps={tooltipSxElevated}>
                    <span>
                        <button className="yns-titlebar-btn" onClick={onSave} disabled={!isDirty}>
                            <SaveOutlinedIcon sx={{ fontSize: 15 }} />
                        </button>
                    </span>
                </Tooltip>
                <Tooltip title="Cancel" componentsProps={tooltipSxElevated}>
                    <button className="yns-titlebar-btn" onClick={onCancel}>
                        <CloseIcon sx={{ fontSize: 15 }} />
                    </button>
                </Tooltip>
            </div>
        </div>
    );
}
